let entity = "INBOUND"
export const GET_ALL = `GET_ALL_${entity}`
export const GET_ALL_SUCCESS = `GET_ALL_${entity}_SUCCESS`
export const GET_ALL_FAIL = `GET_ALL_${entity}_FAIL`


export const GET_ALL_ASSIGNED = `GET_ALL_ASSIGNED_${entity}`
export const GET_ALL_ASSIGNED_SUCCESS = `GET_ALL_ASSIGNED_${entity}_SUCCESS`
export const GET_ALL_ASSIGNED_FAIL = `GET_ALL_ASSIGNED_${entity}_FAIL`

export const GET_ALL_NOTASSIGNED = `GET_ALL_NOTASSIGNED_${entity}`
export const GET_ALL_NOTASSIGNED_SUCCESS = `GET_ALL_NOTASSIGNED_${entity}_SUCCESS`
export const GET_ALL_NOTASSIGNED_FAIL = `GET_ALL_NOTASSIGNED_${entity}_FAIL`


export const GET_ALL_PROCCESS = `GET_ALL_PROCCESS_${entity}`
export const GET_ALL_PROCCESS_SUCCESS = `GET_ALL_PROCCESS_${entity}_SUCCESS`
export const GET_ALL_PROCCESS_FAIL = `GET_ALL_PROCCESS_${entity}_FAIL`


export const GET_ALL_PAGETYPE = `GET_ALL_PAGETYPE_${entity}`
export const GET_ALL_PAGETYPE_SUCCESS = `GET_ALL_PAGETYPE_${entity}_SUCCESS`
export const GET_ALL_PAGETYPE_FAIL = `GET_ALL_PAGETYPE_${entity}_FAIL`


export const GET_ALL_STATES = `GET_ALL_STATES_${entity}`
export const GET_ALL_STATES_SUCCESS = `GET_ALL_STATES_${entity}_SUCCESS`
export const GET_ALL_STATES_FAIL = `GET_ALL_STATES_${entity}_FAIL`

export const GET_ALL_ASSIGNED_FOR_DOCUMENTID = `GET_ALL_ASSIGNED_FOR_DOCUMENTID_${entity}`
export const GET_ALL_ASSIGNED_FOR_DOCUMENTID_SUCCESS = `GET_ALL_ASSIGNED_FOR_DOCUMENTID_${entity}_SUCCESS`
export const GET_ALL_ASSIGNED_FOR_DOCUMENTID_FAIL = `GET_ALL_ASSIGNED_FOR_DOCUMENTID_${entity}_FAIL`




export const GET_ALL_REJECTION_REASON = `GET_ALL_REJECTION_REASON_${entity}`
export const GET_ALL_REJECTION_REASON_SUCCESS = `GET_ALL_REJECTION_REASON_${entity}_SUCCESS`
export const GET_ALL_REJECTION_REASON_FAIL = `GET_ALL_REJECTION_REASON_${entity}_FAIL`


export const GET = `GET_${entity}`
export const GET_SUCCESS = `GET_${entity}_SUCCESS`
export const GET_FAIL = `GET_${entity}_FAIL`

export const GET_BY_DOCUMENT_NUMBER = `GET_BY_DOCUMENT_NUMBER_${entity}`
export const GET_BY_DOCUMENT_NUMBER_SUCCESS = `GET_BY_DOCUMENT_NUMBER_${entity}_SUCCESS`
export const GET_BY_DOCUMENT_NUMBER_FAIL = `GET_BY_DOCUMENT_NUMBER_${entity}_FAIL`

export const SAVE = `SAVE_${entity}`
export const SAVE_SUCCESS = `SAVE_${entity}_SUCCESS`
export const SAVE_FAIL = `SAVE_${entity}_FAIL`

export const SAVEASSIGNED = `SAVEASSIGNED_${entity}`
export const SAVEASSIGNED_SUCCESS = `SAVEASSIGNED_${entity}_SUCCESS`
export const SAVEASSIGNED_FAIL = `SAVEASSIGNED_${entity}_FAIL`

export const SAVEATTACHS = `SAVEATTACHS_${entity}`
export const SAVEATTACHS_SUCCESS = `SAVEATTACHS_${entity}_SUCCESS`
export const SAVEATTACHS_FAIL = `SAVEATTACHS_${entity}_FAIL`


export const SAVEAPROVAL = `SAVEAPROVAL${entity}`
export const SAVEAPROVAL_SUCCESS = `SAVEAPROVAL${entity}_SUCCESS`
export const SAVEAPROVAL_FAIL = `SAVEAPROVAL${entity}_FAIL`


export const SAVEREACTIVE = `SAVEREACTIVE${entity}`
export const SAVEREACTIVE_SUCCESS = `SAVEREACTIVE${entity}_SUCCESS`
export const SAVEREACTIVE_FAIL = `SAVEREACTIVE${entity}_FAIL`

export const UPDATE = `UPDATE_${entity}`
export const UPDATE_SUCCESS = `UPDATE_${entity}_SUCCESS`
export const UPDATE_FAIL = `UPDATE_${entity}_FAIL` 

export const DISSASOCIATE = `DISSASOCIATE_${entity}`
export const DISSASOCIATE_SUCCESS = `DISSASOCIATE_${entity}_SUCCESS`
export const DISSASOCIATE_FAIL = `DISSASOCIATE_${entity}_FAIL` 

export const REJECT = `REJECT_${entity}`
export const REJECT_SUCCESS = `REJECT_${entity}_SUCCESS`
export const REJECT_FAIL = `REJECT_${entity}_FAIL` 

export const ASSOCIATE = `ASSOCIATE_${entity}`
export const ASSOCIATE_SUCCESS = `ASSOCIATE_${entity}_SUCCESS`
export const ASSOCIATE_FAIL = `ASSOCIATE_${entity}_FAIL` 

export const OPEN = `OPEN${entity}`
export const OPEN_SUCCESS = `OPEN_${entity}_SUCCESS`
export const OPEN_FAIL = `OPEN_${entity}_FAIL` 

export const GET_XML_TRANSSMITIONS = `XML_TRANSSMITIONS_${entity}`
export const GET_XML_TRANSSMITIONS_SUCCESS = `XML_TRANSSMITIONS_${entity}_SUCCESS`
export const GET_XML_TRANSSMITIONS_FAIL = `XML_TRANSSMITIONS_${entity}_FAIL` 

export const TYPES = `TYPES_${entity}`
export const TYPES_SUCCESS = `TYPES_${entity}_SUCCESS`
export const TYPES_FAIL = `TYPES_${entity}_FAIL` 

export const UPDATE_TYPES = `UPDATE_TYPES_${entity}`
export const UPDATE_TYPES_SUCCESS = `UPDATE_TYPES_${entity}_SUCCESS`
export const UPDATE_TYPES_FAIL = `UPDATE_TYPES_${entity}_FAIL` 

export const DOWNLOAD = `DOWNLOAD_${entity}`;

export const ALLEXPORT = `ALLEXPORT_${entity}`;

export const SET_FILTER = `SET_FILTER_${entity}`;
export const CLEAR_FILTER = `CLEAR_FILTER_${entity}`;

